export default "__VITE_ASSET__CE0e32kO__"